__turbopack_context__.v({
  "service-teaser__benefit": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__benefit",
  "service-teaser__icon": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__icon",
  "service-teaser__icon-bullets": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__icon-bullets",
  "service-teaser__link": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__link",
  "service-teaser__linkable-content": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__linkable-content",
  "service-teaser__wrapper": "service-teaser-component-module-scss-module__5nsoHG__service-teaser__wrapper",
});
